import {
  Box, Button, Collapse, Typography,
} from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDownRounded';
import clsx from 'clsx';
import { SessionComplianceChecklistItem } from '../../../../../../../../LiveContext/Hooks/useSession/useSessionCompliance/type';
import StyledBox from './styles';

function CommandItems(props: { topic: SessionComplianceChecklistItem }) {
  const { topic } = props;
  return (
    <Box>
      <ul>
        {topic.topic.projectCommands?.items.map((command) => (
          <Typography key={command.commandId} component="li">
            {command.command.text}
          </Typography>
        ))}
      </ul>
    </Box>
  );
}

export default function CommandChecklist(props: { topic: SessionComplianceChecklistItem }) {
  const { topic } = props;
  const { t } = useTranslation();
  const [open, setOpen] = React.useState(false);
  if (topic.complianceExample) {
    return (
      <StyledBox className={clsx('collapse', { expanded: open })}>
        <Button
          className="commands-button"
          onClick={() => { setOpen(!open); }}
          fullWidth
          disableRipple
        >
          <ArrowDropDownIcon />
          <Typography variant="subtitle2">
            {t('right-panel.session-compliance.checklist.commands')}
          </Typography>
        </Button>
        <Collapse in={open}>
          <CommandItems topic={topic} />
        </Collapse>
      </StyledBox>
    );
  }
  return (
    <StyledBox>
      <Typography variant="subtitle2">
        {t('right-panel.session-compliance.checklist.commands')}
      </Typography>
      <CommandItems topic={topic} />
    </StyledBox>
  );
}
